// component
import MyAssetsList from './list/index.vue';
import classification from './classification/index.vue';
import MyAssetsAdd from './add/index.vue';
import MyAssetsDetail from './detail/index.vue';
import Assdetail from './assdetail/index.vue';
import resourcesDetail from './resources-detail/index.vue';

export default [
  {
    path: 'list',
    name: 'MyAssetsList',
    component: MyAssetsList,
    meta: {
      title: '资源资产列表',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'classification',
    name: 'classification',
    component: classification,
    meta: {
      title: '资源资产列表',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'add',
    name: 'MyAssetsAdd',
    component: MyAssetsAdd,
    meta: {
      title: '添加资源资产信息',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'MyAssetsDetail',
    component: MyAssetsDetail,
    meta: {
      title: '资源资产信息详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'assdetail',
    name: 'Assdetail',
    component: Assdetail,
    meta: {
      title: '资源资产信息详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  },,
  {
    path: 'resources-detail',
    name: 'resourcesDetail',
    component: resourcesDetail,
    meta: {
      title: '资源资产信息详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];
